/**
 * Stylin' for the contact form container, bro!
 */
export const contactFormContainerStyles = {
  maxWidth: "450px",
  minWidth: "200px",
  bg: "inherit",
  p: 3,
  py: 4,
  borderRadius: 12,
  color: "inherit",
}

/**
 * Stylin' for the heading of the contact form, dude!
 */
export const headingStyles = {
  textAlign: "center",
  width: "100%",
  pb: 3,
  display: "block",
}
